import moment from 'moment';
import { Tooltip } from 'antd';
import React from 'react';
import CurrencyIcon from '../../../Common/CurrencyIcon';
import PlatformIconRender from '../../../Common/PlatformIconRender';

const CampaignBaseDetailsComponent = ({
  name,
  campId,
  budget,
  objective,
  creativesCount,
  posts,
  platform,
  createdAt,
  campaignstatus,
  paymentstatus,
  influencerscount,
}) => {
  return (
    <div className="row campaign_details_base">
      <div className="mx-3">
        <p>Campaign Name</p>
        <h6 className="spl">{name || 'n/a'}</h6>
      </div>
      <div className="mx-3">
        <p>Campaign ID</p>
        <h6 >{campId || 'n/a'}</h6>
      </div>
      <div className="mx-3">
        <p>Platform</p>
        <h6><Tooltip title={platform}><PlatformIconRender platform={platform}
          size={20}/></Tooltip></h6>
      </div>
      <div className="mx-3">
        <p>Objective</p>
        <h6>{objective || 'n/a'}</h6>
      </div>
      <div className="mx-3">
        <p>Status</p>
        <h6>{campaignstatus || 'n/a'}</h6>
      </div>
      <div className="mx-3">
        <p>Payment Status</p>
        <h6>{paymentstatus ? 'Completed':'Pending'}</h6>
      </div>
      <div className="mx-3">
        <p>Created At</p>
        <h6>{moment(createdAt).format('Do MMM YYYY hh:mm a') || 'n/a'}</h6>
      </div>
      <div className="mx-3">
        <p>Budget</p>
        <h6>{CurrencyIcon()}<strong>{budget}</strong></h6>
      </div>
      <div className="mx-3">
        <p>Total Creatives</p>
        <h6>{creativesCount || 'n/a'}</h6>
      </div>
      <div className="mx-3">
        <p>Est. Influencers</p>
        <h6>{influencerscount}</h6>
      </div>
    </div>
  );
};

export default CampaignBaseDetailsComponent;
